export default function isBase64(property) {
  return property.substr(0, 5) === 'data:';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela/es/isBase64.js
// module id = 577
// module chunks = 1